<div class="container customer-search" pos-relative>

  <div class="row cc-panel">
    <div class="col-md-12 col-lg-7">
      <div class="row">
        <div class="col-md-12">
          <h3 class="section-heading">Customer Search</h3>
        </div>
      </div>
      <form [formGroup]="customerSearchForm" autocomplete="off" id="txtCustomerForm">
        <!-- @author Vamsi.Pamidala disableDropdown function is created for common use both customer search pages -->
        <div class="row row-bottom-space">
          <div class="col-md-4" *ngIf="false">
            <app-alight-drop-down [group]="customerSearchForm" [controlName]="'clientId'" [required]="false"
              description="clientName" [disable]="rootService.disableDropdown()" label="Client" [value]="'clientId'" [list]="
                rootService.liveChatCTS.length < 2
                  ? customerService.clients
                  : rootService.liveChatCTS
              " (change)="onClientDropDownChange($event)">
            </app-alight-drop-down>
          </div>
          <div class="col-md-6" >
      
                 <app-alight-smart-search-drop-down [group]="customerSearchForm" [controlName]="'clientName'" [required]="true" (change)="onClientChange($event)"
            description="clientName" [disable]="rootService.disableDropdown()" label="Client" [value]="'clientName'"
            [list]="rootService.liveChatCTS.length < 2? customerService.clients: rootService.liveChatCTS" [required]="true">
          </app-alight-smart-search-drop-down>
          	         
          </div>
          <div class="col-md-4">
       
          </div>

      <div class="col-md-4" *ngIf="false">
        <app-alight-drop-down [group]="customerSearchForm" [controlName]="'customerType'" value="fieldValue"
          description="fieldValueDescription" label="Customer Type" [list]="customers"></app-alight-drop-down>
      </div>
    </div>

        <div class="row row-bottom-space">
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box" [ngClass]="{ 'error-border': invalid }">
              <mat-label>Last Name (Required)</mat-label>
              <input matInput formControlName="lastName" autocomplete="off" id="lastName" (focus)="onFocus($event)"
                (keyup)="onKeyUp($event, 'lastName')" />
              <mat-error *ngIf="
            errorHandling('lastName', 'required') ||
            errorHandling('lastName', 'pattern')
          ">
                <i class="fa-solid fa-circle-xmark"></i>
                {{ errorMsg.lastName }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" id="firstName" (focus)="onFocus($event)" />
            </mat-form-field>
          </div>
          
        </div>

        <div class="row row-bottom-space">
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box" [ngClass]="{ 'error-border': invalid }">
              <mat-label>Date of Birth (MM/DD/YYYY)</mat-label>
              <input matInput formControlName="dateOfBirth" id="dateOfBirth" (keyup)="onKeyUp($event, 'dateOfBirth')"
                (focus)="onFocus($event)" />
              <mat-error *ngIf="errorHandling('dateOfBirth', 'pattern')">
                <i class="fa-solid fa-circle-xmark"></i>
                {{ errorMsg.dateOfBirth }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box" [ngClass]="{ 'error-border': invalid }">
              <mat-label>National ID (Last 4)</mat-label>
              <input matInput formControlName="nationalId" maxlength="4" id="nationalId" (focus)="onFocus($event)"
                (keyup)="onKeyUp($event, 'nationalId')" />
              <mat-error *ngIf="
              errorHandling('nationalId', 'minlength') ||
              errorHandling('nationalId', 'pattern')
            ">
                <i class="fa-solid fa-circle-xmark"></i>
                {{ errorMsg.nationalId }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box error-border">
              <mat-label>Employee ID</mat-label>
              <input matInput formControlName="employeeId" id="employeeId" (focus)="onFocus($event)" />
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Postal Code</mat-label>
              <input matInput formControlName="postalCode" id="postalCode" (focus)="onFocus($event)" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-button-controls">
              <f-button text="Clear all" type="button" variant="action" (buttonClicked)="clearAll()"></f-button>
              <f-button text="Search" type="submit" variant="progressive" uuid="txtSearch" disabled="{{
             this.checkSearchDisable()
            }}" (buttonClicked)="submit()">
              </f-button>
            </div>
          </div>
        </div>
      </form>

    </div>

    <div class="col-md-12 col-lg-5"  >
      <f-data-card class="pos-relative clientInfo">
        
        <h3 class="section-heading">Client Info</h3>
        <section class="error-wrapper" *ngIf="custAccService.checkDefaultPinLoadApiFail()" >
          <f-alert variant="error">
            <p> There was a problem loading the data. <button class="btn-alert" (click)="custAccService.getDefaultPin()">Try again</button> </p>
          </f-alert>
        </section>
        <section  class="error-wrapper" *ngIf="custAccService.checkCreateUpdateDefaultPinApiFail()">
          <f-alert variant="error">
            Unable to update default pin please try again on clicking of hollow pin icon
          </f-alert>
        </section>

        <section class="no-result" *ngIf="rootService.displayNoDataMsgOnClientInfoCard(clientId)">                 
          <p> No data available </p>                  
      </section>

      <app-carousel *ngIf="!rootService.displayNoDataMsgOnClientInfoCard(clientId)" [cardComponents]="rootService.clientInfoCard.clientInfoVSClientIdMap[clientId]"></app-carousel>
       </f-data-card>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <h3 class="search-result">Customer Search Results</h3>
    </div>
    <div class="col-md-8">
      <h3 class="display-result" *ngIf="totalRecords > 0 && totalRecords <= 50">

        Displaying
        <strong>{{ alightTable?.totalCount }}</strong> records
      </h3>
      <!-- <h3 class="display-reult" *ngIf="totalRecords == 0">No results found</h3> -->
    </div>
  </div>
  <app-alight-table [dataSource]="dataSource" [totalRecords]="totalRecords" [gridColumns]="Columns" [rowPerPage]="10"
    (rowSelection)="rowSelection($event)" [disableButtons]="rootService.isDuplicateCustSearchTabOpened"
    [hideReplaceAddButton]="false"></app-alight-table>

  <!-- Custom Dialog for CCR1-26 and CCR1-28 -->
  <div class="custom-overlay-container additional-account" *ngIf="isModalOpen">
    <div class="custom-overlay-body">
      <div class="custom-overlay-content" role="dialog">
        <app-additional-account-modal id="content" [activeChatCustomers]="activeChatCustomers" [data]="accountModal"
          (buttonClicked)="buttonEvent($event)"></app-additional-account-modal>
      </div>
    </div>
  </div>

  <app-custom-dialog *ngIf="rootService.customDialogData.displayCustomDialogCS" (actionOnClick)="buttonClick($event)">
  </app-custom-dialog>

  <!-- Custom Dialog popup if already opened addtional customer or call just disconnected  -->
  <!-- <app-custom-dialog class="hide" additionalClass="additional-account">
    <div id="content">
      <p class="hide">
        An additional account is already open. It must close before another can
        open.
      </p>
      <p class="hide1">
        The additional customer account opened must be closed first.
      </p>

      <div class="custom-overlay-footer">
        <f-button
          text="Cancel"
          mat-dialog-close
          tabindex="1"
          buttonTitle="Cancel"
          type="button"
          variant="action"
        ></f-button>

        <f-button
          text="Close Additional Account"
          mat-dialog-close
          tabindex="1"
          buttonTitle="Close Additional Account"
          type="button"
          variant="progressive"
        ></f-button>
      </div>
    </div>
  </app-custom-dialog> -->

  <!-- Custom Dialog popup Open Multiple Additional Customer Account on a Chat CCR1-1202  -->
  <!-- <app-custom-dialog class="hide">
    <div id="content">
      <p>
        {{ AdditionalAccountChatMsg }}
      </p>
      <div class="custom-overlay-footer">
        <f-button
          text="Cancel"
          mat-dialog-close
          tabindex="1"
          buttonTitle="Cancel"
          type="button"
          variant="action"
        >
        </f-button>
        <f-button
          text="Close Additional Account"
          mat-dialog-close
          tabindex="2"
          buttonTitle="Close Additional Account"
          type="button"
          variant="progressive"
        >
        </f-button>
      </div>
    </div>
  </app-custom-dialog> -->
  <!-- <div class="row">
    <div class="col-md-12">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" matSort (matSortChange)="sortChange()" >
       
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef  [resizeColumn]="true"><span mat-sort-header> Last Name </span></th>
          <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
        </ng-container>
       
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true"><span mat-sort-header> First Name </span></th>
          <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
        </ng-container>


        <ng-container matColumnDef="dateOfBirth">
          <th mat-header-cell *matHeaderCellDef class="col-date"><span mat-sort-header> Date of Birth </span></th>
          <td mat-cell *matCellDef="let element"> {{element.dateOfBirth| date:'MM/dd/yyyy'}} </td>
        </ng-container>

        <ng-container matColumnDef="nationalId">
          <th mat-header-cell *matHeaderCellDef class="col-width-80"> <span mat-sort-header> National ID </span></th>
          <td mat-cell *matCellDef="let element"> {{element.nationalId}} </td>
        </ng-container>

        <ng-container matColumnDef="employeeId">
          <th mat-header-cell *matHeaderCellDef class="col-width-80"><span mat-sort-header> Emp ID </span></th>
          <td mat-cell *matCellDef="let element"> {{element.employeeId}} </td>
        </ng-container>


        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" class="col-address"><span mat-sort-header> Address
            </span></th>
          <td mat-cell *matCellDef="let element"> {{element.address}} </td>
        </ng-container>

        <ng-container matColumnDef="zipCode">
          <th mat-header-cell *matHeaderCellDef class="col-width-80"><span mat-sort-header> Zip Code</span></th>
          <td mat-cell *matCellDef="let element">{{element.zipCode}} </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"  (dblclick)="rowSelection(row)" (keydown.enter)="onTableRowEnter(row);"  (focusin)="selectedRow = row;"
          [ngClass]="{ 'selected': row === selectedRow }" tabindex="0"></tr>
      </table>

      <div class="footer-controls" [style.visibility]="(paginator && totalRecords>0 && totalRecords<=50) ? 'visible' : 'hidden' ">
      
        <div class="footer-controls-left">     
          <f-button text="Previous" disabled="{{isPreviousDisabled}}" type="button" variant="progressive" (buttonClicked)="previousAndNext(false)" (focusin)="tableFocusout()"></f-button>
          <f-button text="Next" disabled="{{isNextDisabled}}" type="button" class="m-none" (buttonClicked)="previousAndNext(true)" (focusin)="tableFocusout()"></f-button>
        </div>

        <div class="footer-controls-mid">
          <f-button text="Go to Customer Account" disabled="{{selectedRow?false:true}}" (buttonClicked)="redirectToCustomerAccount(selectedRow)" type="button" variant="progressive"></f-button>
        </div>
        <div class="footer-controls-right">
          <mat-form-field appearance="fill" class="component-box pagination-input"
            *ngIf="paginator && totalRecords>0 && totalRecords<=50">
            <input matInput placeholder="1" maxlength="1" [value]='paginator.pageIndex +1' (keyup)="pageNumber($event)" (input)="tableFocusout()">
          </mat-form-field>
          <p *ngIf="totalRecords>0 && totalRecords<=50">of <span>{{totalPage}}</span></p>
        </div>


      </div>

      <mat-paginator [pageSizeOptions]="[10]" [ngStyle]="{display: 'none'}" showFirstLastButtons="true"
        hidePageSize="true" aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
  </div> -->
  <app-loader *ngIf="rootService.custSearchLoader" [loaderType]="loaderType"
    [loaderMsg]="rootService.showCustSearchLoaderMsg"></app-loader>
</div>